module.exports = __webpack_public_path__ + "static/CircularStd-Book-130373158ef22bb62b1f486d38c2275d.ttf";